module.exports = __webpack_public_path__ + "img/NoKnownCopyright.4103e043.svg";